<div
  class="flex items-center flex-col justify-center p-3 h-full"
  [class.py-60]="hasBigPadding()"
>
  <ng-content></ng-content>
  <span class="test-result-block text-base font-medium text-ui-gray-100">
    {{ resultContent() ? 'No Results' : noDataText()}}
  </span>
</div>
